import { Api } from '../helpers';

const tagsModel = {
  addManualTag(url, { order_id, tag_id }) {
    const body = { tag_id, order_id };
    const path = `order/${url}`;
    return Api.post({ path, queryParams: { order_id } }, { body });
  },

  getTags(params) {
    const queryParams = params;
    const path = 'order/get_tags';
    return Api.get({ path, queryParams });
  },
};

export default tagsModel;
